// components/features/sectors/SectorsList.tsx
import { Sector } from "@cabukaka/types";
import TableList, { SelectAction } from "../../ui/TableList";
import SectorRow from "./SectorRow";

interface SectorsListProps {
  sectors: Sector[];
  onAction: (sector: Sector) => void;
  onSelectSectors?: (selectedSectors: Sector[]) => void;
  selectable?: boolean;
  selectActions?: SelectAction[];
}

export default function SectorsList({
  sectors,
  onAction,
  onSelectSectors,
  selectable = false,
  selectActions
}: SectorsListProps) {
  const columns = [
    { header: "Secteur", className: "w-2/5" },
    { header: "Ordre", className: "hidden sm:table-cell w-1/5" },
  ];

  return (
    <TableList
      items={sectors}
      columns={columns}
      getId={(sector) => sector.id}
      onAction={onAction}
      onSelectItems={onSelectSectors}
      selectable={selectable}
      emptyMessage="Aucun secteur trouvé"
      actionColumn={true}
      selectActions={selectActions}
      renderRow={(sector, isSelected, onSelect) => (
        <SectorRow
          key={sector.id}
          sector={sector}
          onAction={onAction}
          onSelect={onSelect}
          isSelected={isSelected}
          selectable={selectable}
        />
      )}
    />
  );
}